<template>
    <pop
        ref="pop"
        class="chime-dialog"
        customClass="agent-lead-dialog"
        :allowClose="true"
    >
        <p 
            class="agent-lead-content" 
            v-html="isRegister ? $t('login.isAgentLeadRegister') : $t('login.isAgentLead')"
        ></p>
        <button class="agent-lead-ok" @click="handleOk">{{ $t('login.loginOk') }}</button>
    </pop>
</template>

<script>

export default {
    i18next: {
        ns: 'common'
    },
    props: {
        isRegister: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleOk() {
            this.$refs.pop.close();
        }
    }
}
</script>
<style lang="scss" scoped>
:deep(.agent-lead-dialog){
    background: #fff;
    padding: 40px 30px 30px;
    border-radius: 4px;
    width: 400px;
}
.agent-lead-content{
    font-size: 14px;
    color: #505050;
    line-height: 20px;
    text-align: center;
}
.agent-lead-ok{
    background: var(--mg-button-background);
    color: #fff;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    margin-top: 30px;
}
</style>